import React from 'react';

function TextareaField({ className = '', ...props }) {
  return <textarea className={className} {...props} />;
}

export default TextareaField;
